import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import TableComponent from '../Table/Table';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function MailingTemplate() {

  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'Id', // accessor is the "key" in the data
      },
      {
        Header: 'Type',
        accessor: 'Type', // accessor is the "key" in the data
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        Cell : (props) => {
          return (
            <>
              <Link to={"/affiliate/settings/mailing-templates/edit?id="+props.row.original.Id}>
                <Button size="sm">Edit</Button>
              </Link>
            </>
          )
        }
      },

    ],
    []
  );
  const [userFilter, setUserFilter] = useState({
    username: ""
  })
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  const [usersPages, setUsersPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [affliate, setAffliate] = useState({});
  const [languages, setLanguages] = useState([]);
  const [language, setLanguage] = useState("");
  const [templates, setTemplates] = useState([]);

  const StoreUser = useSelector((state) => state.user);
  const [affliatePermission, setAffliatePermission] = useState(false)
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const GetTemplates = async (m_page, m_language) => {
      setLoading(true);

      const response = await axios.get(window.__CFG.API + "manager/ListAllTemplates?page="+m_page+"&language="+m_language, {
        headers : {
          "Authorization" : "Bearer "+localStorage.getItem("raff-token")
        }
      })

      setLoading(false);

      if(response.data.Error == null) {
        setTemplates(response.data.Result);
      }
  }

  const GetLanguages = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
      headers : {
        "Authorization" : "Bearer "+localStorage.getItem("raff-token")
      }
    })

    if(response.data.Error == null) {
      setLanguages(response.data.Result)
    }
  }

  useEffect(() => {
    GetLanguages();
  }, []);

  useEffect(() => {
    if(language != "") {
      GetTemplates(currentPage, language);
    }
  }, [language, currentPage])

  return (
    <Container>
      <Row >

        <Col>

          <Row className="justify-content-between mt-4" style={{ paddingBottom: 50, margin: 0 }}>
            <Col style={{ display : "flex", gap : 10, alignItems : "center"}}>

              <Col style={{ margin: 0 }}>
                <div className='add-affiliate-searchInput'>
                  <div style={{ position: "", display : "flex" }} className="search-container">
                    <Form.Select onChange={e => setLanguage(e.target.value)} style={{ padding: 5, minWidth: 190 }} type="text" className="search-input" placeholder="Language">
                      <option value="">Language</option>
                      {
                        languages.filter(d => {
                          return d.value != ""
                        }).map(language => {
                          return (
                            <option value={language.value}>{language.label}</option>
                          )
                        })
                      }
                    </Form.Select>
                  </div>
                </div>
              </Col>
              <Button onClick={() => navigate("/affiliate/settings/mailing-templates/create")}>Create Template</Button>
            </Col>

          </Row>


          <Row className="mt-0 mb-0">
            <div className="aff-dash-summary-table">
              <TableComponent columns={columns} data={templates} actions={true} currentPage={currentPage} Pages={usersPages} onPageChange={handlePageChange} loading={loading} ActionLink={(row) => `/affiliate/settings/users/details?id=` + row.id} navigationColumn={affliatePermission ? "id" : ""} />
            </div>
          </Row>

        </Col>
      </Row>


    </Container>
  )
}

export default MailingTemplate